import script from "./IntegratedLinkedInPosts.vue?vue&type=script&setup=true&lang=js"
export * from "./IntegratedLinkedInPosts.vue?vue&type=script&setup=true&lang=js"

import "./IntegratedLinkedInPosts.vue?vue&type=style&index=0&id=62db38b4&lang=scss"

const __exports__ = script;

export default __exports__